import {defineStore} from "pinia";
import axios from "axios";

export const useMapStore = defineStore({
    id: "projectsStore",
    state: () => ({
        isMapLoading: false,
        mapNewsList: [],
        mapFullNewsList: [],
        mapRatingList: [],
        test: null
    }),
    actions: {
        async getMapNewsList(projectId, mapName, date,
                             filters = {blocksIds: [], rubricsIds: [], importanceValues: []}) {
            let loaderTimer = null;
            let loaderShownAt = null;

            try {
                // Спиннер появится через 300мс
                loaderTimer = setTimeout(() => {
                    this.isMapLoading = true;
                    loaderShownAt = Date.now();
                }, 300);

                const params = new URLSearchParams({
                    mapName,
                    dateFrom: date.dateFrom,
                    dateTo: date.dateTo
                });

                const response = await axios.post(
                    `/globus/api/News/map/${projectId}/cards?${params}`,
                    filters
                );

                clearTimeout(loaderTimer);

                if (filters.blocksIds.length === 0 && filters.rubricsIds.length === 0) {
                    this.mapNewsList = [];
                    this.mapRatingList = [];
                } else {
                    this.mapNewsList = response.data.cityCards;
                    this.mapRatingList = response.data.ratings;
                }

                // Если спиннер был показан, держим его минимум 1 секунду
                if (loaderShownAt) {
                    const elapsed = Date.now() - loaderShownAt;
                    const remainingTime = Math.max(0, 1000 - elapsed);

                    await new Promise(resolve => setTimeout(resolve, remainingTime));
                }

                this.isMapLoading = false;

                return {mapNewsList: response.data.cityCards, mapRatingList: response.data.ratings};
            } catch (error) {
                clearTimeout(loaderTimer);

                // Если спиннер был показан, держим его минимум 1 секунду даже при ошибке
                if (loaderShownAt) {
                    const elapsed = Date.now() - loaderShownAt;
                    const remainingTime = Math.max(0, 1000 - elapsed);

                    await new Promise(resolve => setTimeout(resolve, remainingTime));
                }

                this.isMapLoading = false;
                throw error;
            }
        },

        async getMapFullNews(idList) {
            let loaderTimer = null;
            let loaderShownAt = null;

            try {
                loaderTimer = setTimeout(() => {
                    this.isMapLoading = true;
                    loaderShownAt = Date.now();
                }, 300);

                const response = await axios.post("/globus/api/News/cards/ids/", idList);

                clearTimeout(loaderTimer);

                this.mapFullNewsList = response.data;

                if (loaderShownAt) {
                    const elapsed = Date.now() - loaderShownAt;
                    const remainingTime = Math.max(0, 1000 - elapsed);

                    await new Promise(resolve => setTimeout(resolve, remainingTime));
                }

                this.isMapLoading = false;

                return response.data;
            } catch (error) {
                clearTimeout(loaderTimer);

                if (loaderShownAt) {
                    const elapsed = Date.now() - loaderShownAt;
                    const remainingTime = Math.max(0, 1000 - elapsed);

                    await new Promise(resolve => setTimeout(resolve, remainingTime));
                }

                this.isMapLoading = false;
                throw error;
            }
        },

        async searchRegion(value) {
            try {
                const result = await axios.get(`/globus/api/MapFile/locations/${value}`);
                return result.data;
            } catch (e) {
                console.log(e);
                return [];
            }
        },

        /** Получение списка карт для проекта **/

        async getProjectMapFiles(projectId) {
            try {
                const response = await axios.get(`/globus/api/MapFile/projects/${projectId}/maps`);
                return response.data;
            }  catch (e) {
                console.log(e);
            }

            return [];
        },

        /** Удаление существующий карты **/
        async deleteMap(projectId, mapName) {
          try {
              const response = await axios.delete(`/globus/api/MapFile/projects/${projectId}/maps/${mapName}`);
              return response.data;
          } catch (error) {
              console.log(error);
              throw error;
          }
        },

        /** Создание новой карты из списка существующих. **/
        async createMap(projectId, locationId, mapName) {
            try {
                const response = await axios.post(
                  `/globus/api/MapFile/projects/${projectId}/maps/${locationId}`,
                  { mapName: mapName.trim() },
                  { timeout: 300000 } // 5 минут
                );
                return response.data;
            } catch (error) {
                console.log(error);
                throw error;
            }
        },

        /** Загрузка собственной карты в формате geojson **/
        async uploadMap(projectId, file) {
            try {
                const formData = new FormData();
                formData.append("formFile", file);
                formData.append("MapName", file.name);

                const response = await axios.post(
                  `/globus/api/MapFile/projects/${projectId}/maps/upload`,
                  formData
                );

                return response.data;
            } catch (error) {
                console.error("Ошибка загрузки GeoJSON файла:", error);
                throw error;
            }
        }
    }
});